// import bowser from 'bowser';

const minVersions = {
    chrome: '63',
    msedge: '15',
    firefox: '57',
    safari: '11'
};

/**
 * Helper function to determine if the browser is supported at all.
 * @returns {boolean} False if the platform is definitely not supported.
 */
// const supportedBrowser = () => {
//     if (bowser.msie) {
//         return false;
//     }
//     return true;
// };

// 是否为360浏览器
const is360Brower = () => {
    const u = window.navigator.userAgent;
    let is360 = false;
    const _mime = function(option, value) {
        const mimeTypes = navigator.mimeTypes;
        for (const mt in mimeTypes) {
            if (mimeTypes[mt][option] == value) {
                return true;
            }
        }
        return false;
    };
    if (window.chrome) {
        const chromeVersion = u.replace(/^.*Chrome\/([\d]+).*$/, '$1');
        if (window.chrome.adblock2345 || window.chrome.common2345) {
            match['2345Explorer'] = true;
        } else if (_mime('type', 'application/360softmgrplugin') || _mime('type', 'application/mozilla-npqihooquicklogin')) {
            is360 = true;
        } else if (chromeVersion > 36 && window.showModalDialog) {
            is360 = true;
        } else if (chromeVersion > 45) {
            is360 = _mime('type', 'application/vnd.chromium.remoting-viewer');
            if (!is360 && chromeVersion >= 69) {
                is360 = _mime('type', 'application/hwepass2001.installepass2001') || _mime('type', 'application/asx');
            }
        }
    }
    return is360;
};


// 支持的网站
// const isSupportedBrowser = () => !bowser.isUnsupportedBrowser(minVersions, true) && !is360Brower();


const isWebview = () => {
    const ua = navigator.userAgent;
    return /mata-scratch/i.test(ua);
};

const getMobileOS = () => {
    const ua = navigator.userAgent;
    // console.log(ua);
    if (/android/i.test(ua)) {
        return 'Android';
    } else if ((/iPad|iPhone|iPod/.test(ua)) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return 'iOS';
    }
    return 'PC';
};

/**
 * Helper function to determine if the browser meets the minimum recommended version
 * @returns {boolean} False if the browser isn't a recommended browser, or doesn't
 * meet the minimum version for recommended browsers.
 * NOTE: uses strict_mode==true so that any browser not listed in the minVersions
 *   always returns false
 */

// const recommendedBrowser = () =>
//     !bowser.isUnsupportedBrowser(minVersions, true) ||
//     window.navigator.userAgent.toLowerCase().indexOf('googlebot') !== -1;

export {
    // supportedBrowser as
    // default,
    // recommendedBrowser,
    // isSupportedBrowser,
    isWebview,
    getMobileOS
};